module.exports = __webpack_public_path__ + "media/images/home/okra_half_active-bcc78af38113303de02b9a57e24d6322.png";